var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('td',[_c('expand-component',{class:{'expanded' : _vm.expanded}})],1),_c('td',[_vm._v(_vm._s(_vm.item.fullName))])])}
var staticRenderFns = []

export { render, staticRenderFns }